import React, {useEffect} from "react";
import ReactDOMServer from "react-dom/server";

export default function ToolTip(props) {
    const { children, text = "Tooltip" } = props;
    const html = ReactDOMServer.renderToStaticMarkup(text);

    const show = (e) => {
        const _el = document.getElementById("tooltip");
        if (!_el) return;

        // Set HTML (not text)
        _el.innerHTML = html;

        const rect = e.currentTarget.getBoundingClientRect();

        _el.style.left = `${rect.left + rect.width / 2}px`;
        _el.style.top = `${rect.top}px`;

        // Make visible
        _el.style.display = "block";
        requestAnimationFrame(() => {
            _el.classList.add("show"); // triggers CSS animation
        });


    };

    const remove = () => {
        const _el = document.getElementById("tooltip");
        if (!_el) return;

        _el.classList.remove("show");

        _el.style.display = "none";
        _el.innerHTML = "";
    };



    useEffect(() => {
        return () => {
            remove();
        };
    }, []);

    return (
        <div
            onMouseEnter={show}
            onMouseLeave={remove}
            style={{ display: "inline-block", cursor: "help" }}
        >
            {children}
        </div>
    );
}
